import { getCommissionProgressByCommPayType } from '../../api/commissionProgressApi';
import AccountantCommissionListWrapper from './accountantCommissionListWrapper';
import { Box } from '@mui/material';

const WEBBEY_COLUMNS = [
    // Astern Claims base
    'salesId', 'depositDate', 'customer', 'agent', 'coAgent',
    'commission', 'progress', 'status',
    'productCategory', 'productEnergy',
    'asternDiscount', 'agentDiscount', 'finalPrice',
    'firstPayment', 'firstPaymentDate', 'secondPayment', 'secondPaymentDate',
    // Extra for Webbey
    'repayment',
    'updatedBy', 'updatedOn',
    'actions',
];

export default function WebbeyCommissionList() {
    return (
        <div>
            <Box sx={{ mb: 2 }}>
                <h2 style={{ margin: 0, fontSize: '1.5rem', fontWeight: 700, color: '#0F172A', fontFamily: "'Poppins', sans-serif" }}>Webbey Overriding</h2>
                <p style={{ margin: 0, fontSize: '0.8rem', color: '#64748B', fontFamily: "'Poppins', sans-serif" }}>Webbey overriding commission records</p>
            </Box>
            <AccountantCommissionListWrapper
                apiCall={() => getCommissionProgressByCommPayType("Webbey Commission")}
                visibleColumns={WEBBEY_COLUMNS}
            />
        </div>
    );
}
